import Barcode from './barcode'
import ParcelFacts from './parcelFacts'
import LocationFacts from './locationFacts'
import Access from './access'
import Identity from './identity'
import Signatures from './signatures'
import Feedback from './feedback'
import SupportNote from './supportNote'
import Statuses from './statuses'
import Reallocate from './reallocate'
import ChangeBoxSize from './changeBoxSize'
import Booking from './booking'
import Errors from './errors'
import RepairActions from './repairActions'
import Logs from './logs'

// Box calls each `component` as a plain function, so the bodies' hooks belong to
// the box that holds them: a body must be a function component, since memo(),
// forwardRef() and class components throw on first render. A body must also run
// all its hooks before any early `return null`, since the box outlives the null.
const SECTIONS = [
  { id: 'barcode', component: Barcode, criteria: {} },
  { id: 'parcelFacts', component: ParcelFacts, criteria: {} },
  { id: 'locationFacts', component: LocationFacts, criteria: {} },
  { id: 'access', component: Access, criteria: { isIboxen: true } },
  { id: 'identity', component: Identity, criteria: {} },
  {
    id: 'signatures',
    component: Signatures,
    criteria: { isIboxen: true, hasSignatures: true },
  },
  { id: 'feedback', component: Feedback, criteria: { isIboxen: true } },
  {
    id: 'supportNote',
    component: SupportNote,
    criteria: { isIboxen: true, permission: 'viewSupportNote' },
  },
  { id: 'statuses', component: Statuses, criteria: {} },
  {
    id: 'reallocate',
    component: Reallocate,
    // `in-box` and `marked-for-return` are here for the super user only, and
    // that half is checked in the body: criteria are an AND of terms, so "on its
    // way, or in a compartment when you are a super user" cannot be said here.
    criteria: {
      status: ['on-way', 'pickup-on-way', 'in-box', 'marked-for-return'],
      permission: 'specifyNewCompartment',
    },
  },
  {
    id: 'changeBoxSize',
    component: ChangeBoxSize,
    criteria: {
      canChangeBoxSize: true,
      permission: 'requestLargerCompartment',
    },
  },
  {
    id: 'booking',
    component: Booking,
    criteria: {
      status: ['created', 'pickup-created'],
      permission: 'parcelAddStatus',
    },
  },
  // criteria {} on purpose: this part holds the error list (created parcels with
  // errors) and the no-controller warning (any status), and criteria are an AND
  // of terms that cannot say "either". It gates both blocks itself.
  { id: 'errors', component: Errors, criteria: {} },
  {
    id: 'repairActions',
    component: RepairActions,
    criteria: { isIboxen: true },
  },
  { id: 'logs', component: Logs, criteria: {} },
]

export { SECTIONS }
